module.exports = __webpack_public_path__ + "static/media/clinical-trials-600x400.cfb025f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/home/assets/clinical-trials-600x400.jpg
// module id = 1085
// module chunks = 1